import store from '../store'
import { C_ADD_SITE_ALERT } from './mutation-types'
import { getMapRegions } from '@/services/maps-service'
import { isAuthorized as commonIsAuthorized, userHasAnyRole, SMARTTRANSIT_ROLES } from '@smarttransit/common'

let regions = []
let regionsCacheTime = 0
let regionTtlHours = 1

const _getCachedRegions = async function () {
  if (!regions.length || Date.now() - regionsCacheTime > (60000 * 60 * regionTtlHours)) {
    regionsCacheTime = Date.now()
    regions = await getMapRegions()
  }
  return regions
}

const _hasTransportationRole = function (user, transportationRole, transportationOwnerId, transportationOwnerUser = undefined) {
  if (user) {
    const _transportationOwnerUser = transportationOwnerUser || user.transportationOwnerUsers.find((o) => (o.transportationOwnerId + '' === transportationOwnerId + ''))

    if (_transportationOwnerUser) {
      _transportationOwnerUser.roles = Array.isArray(_transportationOwnerUser.roles) ? _transportationOwnerUser.roles : (_transportationOwnerUser?.roles?.split(',') || [])
      return _transportationOwnerUser.roles.find((o) => (o === transportationRole.toUpperCase()))
    }
  }
}

const _isAuthorized = function (user, role) {
  const mappedRole = role === 'staff' ? 'staffIncludingInvestor' : role
  return commonIsAuthorized(user, mappedRole)
}

function _initBreadcrumbs () {
  const breadcrumbs = []
  if ((this.$router?.currentRoute?.matched || []).length) {
    let foundCurrentRoute
    this.$router.currentRoute.matched.forEach((route, index) => {
      if (!foundCurrentRoute) {
        const routeObj = this.$router.resolve({ name: route.name, params: this.$router.currentRoute.params })
        foundCurrentRoute = (routeObj.route.name === this.$router.currentRoute.name)
        if (routeObj) {
          let accountName = index === 1 && this.$props.selectedAccount ? this.$props.selectedAccount.companyName : (routeObj.route.meta.title || routeObj.route.name)
          accountName = accountName.length > 30 ? accountName.substring(0, 30) + '...' : accountName
          breadcrumbs.push({
            text: accountName,
            disabled: foundCurrentRoute,
            to: { name: routeObj.route.name, params: this.$router.currentRoute.params, query: this.$router.currentRoute.query },
            'active-class': foundCurrentRoute ? 'v-breadcrumbs__item--disabled' : ''
          })
        }
      }
    })
  }
  return breadcrumbs
}

function _addAlert ({ message, type, isModal }) {
  if (type === 'error') {
    console.error('addAlert message', message)
  }

  const parsedMessage = (message && typeof message === 'object') ? (message.error && message.error.message ? message.error.message : (message.message ? message.message : JSON.stringify(message))) : message

  if (isModal) {
    alert(parsedMessage)
  } else {
    store.commit(C_ADD_SITE_ALERT, {
      message: parsedMessage,
      type,
      transient: type === 'success'
    })
  }
}

const _isOnlyInvestor = function (user) {
  if (!user || !user.roles) return false
  const hasInvestor = user.roles.some((r) => r.name === 'investor')
  const hasHigherRole = user.roles.some((r) => ['superadmin', 'admin', 'staff'].indexOf(r.name) !== -1)
  return hasInvestor && !hasHigherRole
}

const _getMostRecentTransportationOwnerUser = function (user) {
  const transportationOwnerUsers = user && Array.isArray(user.transportationOwnerUsers) ? user.transportationOwnerUsers : []
  const attachedOwnerUsers = transportationOwnerUsers.filter((item) => item && item.transportationOwnerId)

  if (!attachedOwnerUsers.length) {
    return null
  }

  function recencyScore (transportationOwnerUser) {
    if (!transportationOwnerUser) {
      return 0
    }

    const owner = transportationOwnerUser.transportationOwner || {}
    const candidateDate = transportationOwnerUser.dateUpdated ||
      transportationOwnerUser.dateCreated ||
      owner.dateUpdated ||
      owner.dateCreated

    const parsedDate = candidateDate ? new Date(candidateDate).getTime() : 0
    if (!Number.isNaN(parsedDate) && parsedDate > 0) {
      return parsedDate
    }

    return Number(transportationOwnerUser.transportationOwnerId || 0)
  }

  const sortedOwnerUsers = attachedOwnerUsers.slice().sort((left, right) => {
    return recencyScore(right) - recencyScore(left)
  })

  return sortedOwnerUsers[0] || null
}

const _getMostRecentTransportationOwnerId = function (user) {
  const transportationOwnerUser = _getMostRecentTransportationOwnerUser(user)
  return transportationOwnerUser && transportationOwnerUser.transportationOwnerId
    ? transportationOwnerUser.transportationOwnerId
    : null
}

const _ROOT_EMAIL = 'root@smarttransit.io'

export const staffUserTypes = SMARTTRANSIT_ROLES
export const hasTransportationRole = _hasTransportationRole
export const getCachedRegions = _getCachedRegions
export const isAuthorized = _isAuthorized
export { userHasAnyRole }
export const isOnlyInvestor = _isOnlyInvestor
export const getMostRecentTransportationOwnerUser = _getMostRecentTransportationOwnerUser
export const getMostRecentTransportationOwnerId = _getMostRecentTransportationOwnerId
export const initBreadcrumbs = _initBreadcrumbs
export const addAlert = _addAlert
export const ROOT_EMAIL = _ROOT_EMAIL
